import Image from "next/image";
import Computer from "assets/img/landing/computer.png";
import Mobile from "assets/img/landing/mobile.png";
import { useTranslation } from "react-i18next";

function index() {
  const { t, i18n } = useTranslation();

  return (
    <div className="bg-[#F7EDEB] px-5 xl:px-5 py-15" id="UserInterface">
      <div className="container m-auto ">
        <div className="text-3xl font-bold text-center ">
          {t("Our PLATFORM USER Interface")}
        </div>
        <div
          className={`mt-15 text-center md:text-left ${
            i18n.language === "en" ? "md:text-left" : "md:text-right"
          }`}
        >
          <div className="flex flex-wrap items-center justify-center gap-3 md:flex-nowrap md:justify-between md:items-start md:gap-10">
            <div className="w-[50%] md:w-full">
              <Image quality={40} className="" src={Computer} alt="img" />
            </div>
            <div className="w-[664px] mt-10">
              <div className="font-bold">
                {t("PRECISION FARM MANAGEMENT PLATFORM-Web and Mobile App")}
              </div>
              <div className="text-[#7E7E7E] mt-3 md:mt-0">
                {t(
                  "Through this platform farm manager can access the digital twin of his farm and track all daily activities and farm performance through operations and sensors data empowered with set of digital tools that help him in his day- to-day operations."
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3 -mt-0 md:flex-nowrap md:justify-between md:items-end md:gap-64 md:-mt-28">
            <div className="w-[664px] -mt-0  md:-mt-10">
              <div className="mt-3 font-bold md:mt-0">
                {t("DIGITAL AGRONOMIST CHATBOT")}
              </div>
              <div className="text-[#7E7E7E] mt-3 md:mt-0">
                {t(
                  "It acts as artificial agronomist by utilizing the artificial intelligence system plus ingesting data coming from farm activity, ground sensors, satellite imagery and crop & soil modeling and performance"
                )}
              </div>
            </div>
            <div className="">
              <Image quality={40} className="" src={Mobile} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
